// Institute of Design and Innovation (email idi@unm.edu). //

import store from '../store/store'
import AuthService from '@/common/authService'
import { RouteLocation } from 'vue-router'

/**
 * Navigation guard that requires the user to be logged in
 */
export default async function (to: RouteLocation, from, next) {
  const hasPermission = AuthService.authorize(store.getters.permissionValue, to.meta.requiredPermission)
  if (hasPermission) {
    next()
  } else {
    next(false)
  }
}
